<template>
	<div>
		<v-alert icon="mdi-file-excel" prominent text type="info">
			<v-row>
				<v-col cols="12">
					{{ transactionTitle }}
				</v-col>
			</v-row>
		</v-alert>

		<v-form ref="form" class="mx-2" lazy-validation>
			<v-row>
				<v-col cols="12" md="6">
					<div>
						<div class="mb-2">تاریخ شروع:</div>
						<date-picker ref="startDate" @input="startDate_persian = $event" v-model="startDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" />
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<div>
						<div class="mb-2">تاریخ پایان:</div>
						<date-picker ref="endDate" @input="endDate_persian = $event" v-model="endDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" />
					</div>
				</v-col>
			</v-row>
		</v-form>
		<v-card-actions class="mt-3">
			<export-excel-server :loading="loadingExportExcel" :items="items" :fetch="fetchExcelData" :headers="headers" :fileName="excelFileName" :useButton="false">
				<v-btn color="blue" dark :loading="loadingExportExcel">
					دریافت
				</v-btn>
			</export-excel-server>

		</v-card-actions>
	</div>
</template>

<script>
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'ModifyLoanPaymentView',
		components: {
			'date-picker': VuePersianDatetimePicker,
		},
		props: {
			data: { type: Array },
			headers: { type: Array },
			paymentMethod: { type: Number }
		},
		data() {
			return {
				endDate: '',
				startDate: '',
				loadingExportExcel: false,
				items: []
			}
		},
		computed: {
			transactionTitle() {
				switch (this.paymentMethod) {
					case 1:
						return 'دریافت فایل اکسل از تراکنش های صندوق'
					case 2:
						return 'دریافت فایل اکسل از تراکنش های بانک'
					case 3:
						return 'دریافت فایل اکسل از جعبه طلا'
					case 4:
						return 'دریافت فایل اکسل از واریز قسط های آنلاین'
					default:
						return 'تراکنش نامعلوم'
						break
				}
			},
			excelFileName() {
				switch (this.paymentMethod) {
					case 1:
						return `تراکنش های صندوق${this.startDate ? ' از تاریخ ' + this.convertToPersian(this.startDate) : ''}${this.endDate ? ' تا تاریخ ' + this.convertToPersian(this.endDate) : ''}`
					case 2:
						return `تراکنش های بانک${this.startDate ? ' از تاریخ ' + this.convertToPersian(this.startDate) : ''}${this.endDate ? ' تا تاریخ ' + this.convertToPersian(this.endDate) : ''}`
					case 3:
						return `تراکنش های جعبه طلا${this.startDate ? ' از تاریخ ' + this.convertToPersian(this.startDate) : ''}${this.endDate ? ' تا تاریخ ' + this.convertToPersian(this.endDate) : ''}`
					case 4:
						return `واریز قسط های آنلاین${this.startDate ? ' از تاریخ ' + this.convertToPersian(this.startDate) : ''}${this.endDate ? ' تا تاریخ ' + this.convertToPersian(this.endDate) : ''}`
					default:
						return 'تراکنش نامعلوم'
						break
				}
			}
		},
		mounted() {
		},
		methods: {
			convertToPersian(gDate) {
				if (!gDate)
					return ''
				return (new Date(gDate).toLocaleDateString('fa-IR')).replace(/\//g, "-")
			},
			async fetchExcelData() {
				await this.exportExcel()
				if (!this.items?.length) {
					toast.error('لیست تراکنش ها خالی است و امکان صدور فایل اکسل وجود ندارد.')
					return
				}
				return this.items
			},
			exportExcel() {
				this.items = []
				this.loadingExportExcel = true
				return api.get('admin/dashboard/TurnOver/' + this.paymentMethod + '?startDate=' + this.startDate + '&endDate=' + this.endDate + '&ignoreLimit=true', null)
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loadingExportExcel = false
					})
			}
		},
	}
</script>
<style></style>
